/**
 * @generated SignedSource<<9dcac44ad4ffa8e5d1618487a9ac86dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortfolioAndRecommendationsDataWrapper_userProfile$data = {
  readonly displayUsername: string;
  readonly hasActivePortfolioSubscription: boolean;
  readonly hasPublishedPortfolio: boolean;
  readonly userReviews: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly avatarImage: {
            readonly uid: string;
          } | null;
          readonly id: string;
        };
        readonly id: string;
      };
    }>;
  };
  readonly " $fragmentType": "PortfolioAndRecommendationsDataWrapper_userProfile";
};
export type PortfolioAndRecommendationsDataWrapper_userProfile$key = {
  readonly " $data"?: PortfolioAndRecommendationsDataWrapper_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"PortfolioAndRecommendationsDataWrapper_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PortfolioAndRecommendationsDataWrapper_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasActivePortfolioSubscription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPublishedPortfolio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "isPositiveReview": true,
            "onlyVisibleToRecipient": false
          }
        }
      ],
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserReviewEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReview",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContraImage",
                      "kind": "LinkedField",
                      "name": "avatarImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "uid",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userReviews(filter:{\"isPositiveReview\":true,\"onlyVisibleToRecipient\":false})"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "ace15bacc8867e9b93334e50b5852865";

export default node;
